import { createContext, useContext } from 'react'


type Verifications = {
  verification_collections?: Maybe<VerificationCollection[]>
}

export type ClientContextType = Maybe<
  (GetClientUserQuery['clientUser'] | ClientVersion) & {
    verifications?: Verifications
  }
>

/**
 * @deprecated Use useRouteForClient, useRouteForCaseAndClient instead
 */
export const useClientContext = (canBeEmpty?: boolean) => {
  const context = useContext<ClientContextType>(ClientContext)
  if (!context && !canBeEmpty) {
    throw new Error('useClientContext must be used within ClientContextProvider')
  }
  return context
}

/**
 * @deprecated Use useRouteForClient, useRouteForCaseAndClient instead
 */
export const ClientContext = createContext<ClientContextType>(null)
export const ClientConsumer = ClientContext.Consumer
export const ClientProvider = ClientContext.Provider
